<template>
<div class="formAdd">
    <div class="field">
  <label class="label ">Nama Produk</label>
  <div class="control has-icons-left">
    <input class="input" type="text" placeholder="Input Nama Product" v-model="name">
  <span class="icon is-small is-left">
      <i class="fa fa-archive" aria-hidden="true"></i>
  </span>
  </div>
</div>

<div class="field">
  <label class="label">Foto Produk</label>
  <div class="control has-icons-left">
    <input class="input" type="url" placeholder="URL Foto Produk" v-model="image_url">
    <span class="icon is-small is-left">
<i class="fas fa-images"></i>
    </span>
  </div>

</div>
<div class="field">
  <label class="label">Harga Barang</label>
  <div class="control has-icons-left">
    <input class="input" type="number" placeholder="Harga Barang" v-model="price">
    <span class="icon is-small is-left">
      <i class="fas fa-money-bill"></i>
    </span>
  </div>
</div>

<div class="field">
  <label class="label">Stock Barang</label>
  <div class="control has-icons-left">
    <input class="input" type="number" placeholder="Stock Barang" v-model="stock">
    <span class="icon is-small is-left">
      <i class="fas fa-boxes"></i>
    </span>
  </div>
</div>
<div class="field is-grouped">
  <div class="control">
    <button class="button is-link" @click="addProduct()">Submit</button>
  </div>
  <div class="control">
    <button class="button is-link is-light" @click="allProduct()">Cancel</button>
  </div>
</div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      name: '',
      image_url: '',
      price: '',
      stock: '',
      host: 'http://localhost:3000'
    }
  },
  methods: {
    allProduct () {
      this.$router.push('/all-product')
    },
    addProduct () {
      console.log(this.name, this.image_url, this.price, this.stock)
      let payload ={
        name: this.name,
          image_url: this.image_url,
          price: this.price,
          stock: this.stock
      }
      this.$store.dispatch('addProduct',payload)
    }
  }
}
</script>

<style>
.formAdd{
    width: 400px;
    justify-content: center;
    text-align: center;
    background-color: rgb(245, 226, 241);
    margin-left: 250px;
    margin-bottom: 50px;
}
</style>
